// src/api/PortalProjectApi.jsx

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const PortalProjectsApi = {
    async getCompanyProjects(companyId) {

        const cleanCompanyId = String(companyId || "").trim();

        if (!cleanCompanyId) {
            throw new Error("Missing companyId.");
        }

        const res = await fetch(
            `${API_BASE_URL}portal/projects?companyId=${encodeURIComponent(cleanCompanyId)}`
        );

        const data = await res.json();

        if (!res.ok || !data.success) {
            throw new Error(data.error || "Failed to load company projects.");
        }

        return data.projects || [];
    }
};